var map = {
	"./discover_1.png": 6768,
	"./discover_10.png": 6487,
	"./discover_11.png": 5293,
	"./discover_12.png": 1088,
	"./discover_2.png": 3267,
	"./discover_3.png": 2271,
	"./discover_4.png": 8329,
	"./discover_5.png": 4053,
	"./discover_6.png": 9574,
	"./discover_7.png": 1307,
	"./discover_8.png": 9843,
	"./discover_9.png": 4678
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 537;